<template>
  <div class="terms">
    <h1>Terms of Use</h1>
    <p>Welcome to Cognify, an AI-powered application designed to assist students with note-taking and knowledge organization. By using Cognify, you agree to the following terms of use:</p>

    <h2>1. Features of Cognify</h2>
    <ul>
      <li>Take notes manually or with the assistance of AI.</li>
      <li>Generate notes from scanned documents or imported files.</li>
      <li>Convert voice notes into text using AI-powered transcription.</li>
      <li>Generate summaries and notes from YouTube videos.</li>
    </ul>

    <h2>2. User Responsibilities</h2>
    <p>Users are responsible for ensuring that any content uploaded, scanned, or transcribed complies with all applicable laws and does not infringe on any third-party rights.</p>

    <h2>3. Data Privacy</h2>
    <p>Cognify respects your privacy. Data processed through the app is not stored permanently unless explicitly stated. Please review our <a href="/privacy">Privacy Policy</a> for more details.</p>

    <h2>4. Limitations</h2>
    <p>Cognify is an AI-based tool that assists with note-taking and organization. It may not always produce accurate results, and its suggestions are for informational purposes only.</p>

    <h2>5. Changes to Terms</h2>
    <p>Cognify reserves the right to update these terms of use at any time. Continued use of the app after updates indicates your acceptance of the changes.</p>

    <p>By using Cognify, you agree to these terms. If you do not agree, please refrain from using the app.</p>
  </div>
</template>

<script>
export default {
  name: "TermsOfUse",
};
</script>

<style scoped>
.terms {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  line-height: 1.6;
}

h1 {
  text-align: center;
  margin-bottom: 20px;
}

a {
  color: #007bff;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>